import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CareerInterface, CareersInterface } from '../../../@core/models/site-data.model';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialCareerComponent implements OnInit {

  title: string;
  textColor: string = '';
  backgroundColor: string = '';
  activatePadding: boolean = false;
  type: any;
  name: string;
  data: CareerInterface;
  active: boolean = false;
  position: number = 0;
  moduleInfo: string;
  careers: CareersInterface[];
  allElementAnimation: string;
  itemsAnimation: string;
  loading: boolean = true;

  constructor(
  ) { }

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.itemsAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;

    }
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : "";
    this.careers = this.data.careers;
    this.loading = false;
  }

}
